











































import { editfollowLogApi } from "@/api/studentFollow";
import { Vue, Prop, Component } from "vue-property-decorator";
@Component
export default class extends Vue {
  @Prop() logData!: any;
  form: any = {
    follow_id: 0,
    content: "",
    pre_follow_time: 0,
  };
  dialogVisible: boolean = false;
  openDialog() {
    this.form = {
      follow_id: this.logData.id,
      content: this.logData.content,
      pre_follow_time: new Date(this.logData.pre_follow_time).getTime(),
    };
    this.dialogVisible = true;
  }
  handleClose() {
    this.dialogVisible = false;
  }
  handleSubmit() {
    editfollowLogApi({
      follow_id: this.form.follow_id,
      content: this.form.content,
      pre_follow_time: Math.floor(this.form.pre_follow_time / 1000),
    }).then(() => {
      this.$message({
        type: "success",
        message: "编辑成功",
      });
      this.$emit("change");
      this.handleClose();
    });
  }
}
